import React, { useContext, useEffect } from 'react'
import { makeStyles } from '@material-ui/core'

import { useCookies } from "react-cookie";

// components
import Header from '../components/Header'
import Footer from '../components/Footer'
import ContentWrap from '../components/ContentWrap'
import WorkoutModal from '../components/WorkoutModal'

// store
import { Context } from '../store'
import types from '../store/types'

import useCustomTracking from '../hooks/useCustomTracking'

// styles
const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    background: '#000'
  },
})

function Layout({ header, title, children, hasContent = true, ...props }) {
  const styles = useStyles()

  // global state
  const { globalState, dispatch } = useContext(Context)
  const { workoutModalVisible, customTriggered, clubData = {} } = globalState;
  const clubId = clubData.id

  const [cookies, setCookie] = useCookies(["locale"]);



  const toggleWorkoutModal = () => {
    dispatch({ type: types.TOGGLE_WORKOUT_MODAL })
  }

  const getTrackingCodes = useCustomTracking();
  const [cookie] = useCookies(["cookieConsentStatus"]);
  const { cookieConsentStatus } = cookie;

  useEffect(() => {
    // trigger custom tracking codes if they accept cookie consent or country doesn't belong to the list
    // custom tracking codes will only be added ones 
    if (cookieConsentStatus && !customTriggered && clubId) getTrackingCodes(clubId);
  }, [cookieConsentStatus, customTriggered, clubId]);

  return (
    <>
      <div className={styles.wrapper} {...props}>
        <Header isError={!hasContent} title={title}>{header}</Header>
        {hasContent && <ContentWrap>{children}</ContentWrap>}
        <Footer />
      </div>
      <WorkoutModal open={workoutModalVisible} onClose={toggleWorkoutModal} />
    </>
  )
}

export default Layout
